<template>
  <div
    :class="[{ app: data.access_type === 'app' }, 'card', 'video-effect']"
    :style="data.containerStyle"
  >
    <div class="step-nav">
      <button type="button" class="move-back" @click="goPrev(step_type)">
        <i class="material-icons">arrow_back_ios</i>
      </button>
    </div>
    <div class="header">
      <h2 v-html="$t('mov_making.step_two', { num: '2. ' })"></h2>
    </div>
    <div class="body">
      <p v-html="$t('mov_making.desc_setting_effect')" class="information"></p>
      <form action="#">
        <div class="type-box">
          <div class="form-box">
            <label
              v-html="
                $t('common.t_name_mov', {
                  isInsertEnter: data.access_type === 'app' ? '<br>' : '',
                })
              "
            ></label>
            <input
              id="mov_name"
              ref="mov_name"
              v-model="data.mov_name"
              type="text"
              maxlength="50"
              @input="titleChange"
            />
            <button
              type="button"
              :class="['button-delete', { show: data.mov_name }]"
              @click="clearMovName()"
            >
              X
            </button>
          </div>
          <div
            :class="{
              hidden: data.access_type === 'app',
              'form-box': data.access_type === 'web',
            }"
          >
            <label v-html="$t('mov_making.add_sticker')"></label>
            <div
              id="drop"
              class="inactive"
              @mouseover="changeClassTo('dragging')"
              @mouseout="changeClassTo('inactive')"
              @mouseclick="changeClassTo('inactive')"
              @dragenter.prevent="getImageHandleDragEnter"
              @dragleave.prevent="getImageHandleDragLeave"
              @dragover.prevent="getImageHandleDragOver"
              @drop.prevent="getImageHandleDragDrop"
            >
              <label
                class="selectedFile"
                for="selectedFile"
                v-html="$t('mov_making.msg_drag_and_drop_to_upload')"
              ></label>
              <input
                id="selectedFile"
                type="file"
                multiple="true"
                accept="image/*"
                @input="selectedFile"
              />
            </div>
          </div>
          <div
            v-show="data.isShowStickerList"
            :class="{
              hidden: data.access_type === 'app',
              'form-box': data.access_type === 'web',
            }"
          >
            <label></label>
            <div id="select-sticker">
              <div class="stickers">
                <div id="image-preview"></div>
              </div>
            </div>
          </div>

          <div
            v-show="data.isShowStickerList"
            :class="{
              hidden: data.access_type === 'app',
              'form-box': data.access_type === 'web',
            }"
          >
            <label v-text="$t('mov_making.remove_sticker')"></label>
            <button
              class="removeButton"
              @click="removeSticker"
              v-text="$t('mov_making.remove_selected_sticker')"
            ></button>
          </div>
          <div :class="{ 'form-box': data.access_type === 'web' }">
            <label
              :class="{
                hidden: data.access_type === 'app',
                'form-box': data.access_type === 'web',
              }"
              v-text="$t('movie_list.sub_btn_preview')"
            ></label>
            <div class="effect">
              <div
                :class="['image-row', { hidden: data.access_type === 'app' }]"
                :style="data.imageStyle"
              >
                <div ref="canvasContainer" class="canvas-box">
                  <img
                    id="previewImage"
                    :src="data.preview_mov"
                    :width="data.width"
                    :height="data.height"
                    alt="Preview Image"
                  />
                  <canvas
                    id="textCanvas"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                </div>
                <div
                  v-show="data.isMultiCanvas"
                  ref="canvasContainerSecond"
                  class="canvas-box"
                >
                  <img
                    id="previewImageSecond"
                    :src="data.preview_mov"
                    :width="data.width"
                    :height="data.height"
                    alt="Preview Image"
                  />
                  <canvas
                    id="textCanvasSecond"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                </div>
              </div>
              <div
                :class="{
                  hidden: data.access_type === 'app',
                  'button-row': data.access_type === 'web',
                }"
              >
                <button
                  v-if="!data.is_play"
                  type="button"
                  class="button primary"
                  @click.prevent="clickPlay"
                >
                  PLAY
                </button>
                <button
                  v-if="data.is_play"
                  type="button"
                  class="button orange"
                  @click.prevent="stopPlay"
                >
                  STOP
                </button>
              </div>
            </div>
          </div>

          <div class="form-box text-tab-form-box">
            <label></label>
            <div class="text-row">
              <ul>
                <li
                  :class="{ 'clicked-tab': data.clicked_text === 1 }"
                  @click.prevent="onTextTab(1)"
                >
                  <span
                    class="text-tab"
                    v-text="`${$t('mov_making.movtxt')}  # 1`"
                  ></span>
                </li>
                <li
                  v-if="data.isShowTab"
                  :class="{ 'clicked-tab': data.clicked_text === 2 }"
                  @click.prevent="onTextTab(2)"
                >
                  <span
                    class="text-tab"
                    v-text="`${$t('mov_making.movtxt')} # 2`"
                  ></span>
                </li>
                <li
                  v-if="data.isShowTab"
                  :class="{ 'clicked-tab': data.clicked_text === 3 }"
                  @click.prevent="onTextTab(3)"
                >
                  <span
                    class="text-tab"
                    v-text="`${$t('mov_making.movtxt')} # 3`"
                  ></span>
                </li>
              </ul>
            </div>
          </div>
          <div v-for="(item, i) in data.text_list" :key="i">
            <div v-if="data.clicked_text === item.index">
              <div
                :class="{
                  hidden: data.access_type === 'app',
                  'form-box': data.access_type === 'web',
                }"
              >
                <label v-text="$t('mov_making.sticker_priority')"></label>
                <div class="radio-box">
                  <input
                    id="text"
                    v-model="data.elementOnTop"
                    type="radio"
                    name="isElementOntop"
                    value="text"
                    :checked="data.elementOnTop === 'text'"
                  />
                  <label
                    for="text"
                    v-html="$t('mov_making.text_on_top')"
                  ></label>
                  <input
                    id="sticker"
                    v-model="data.elementOnTop"
                    type="radio"
                    name="isElementOntop"
                    value="sticker"
                    :checked="data.elementOnTop === 'sticker'"
                  />
                  <label
                    for="sticker"
                    v-html="$t('mov_making.sticker_on_top')"
                  ></label>
                </div>
              </div>
              <div v-if="!data.isShowTab" class="form-box">
                <label></label>
                <label
                  class="help"
                  v-text="
                    $t('mov_making.tab_prevent', {
                      animation_name: $t(
                        `mov_making.${data.text_list[0].animation_name}`,
                      ),
                    })
                  "
                ></label>
              </div>
              <div class="form-box">
                <label
                  v-html="
                    `${$t('mov_making.first_line')}<br>${$t(
                      'mov_making.text_size',
                    )}`
                  "
                ></label>
                <div class="radio-box">
                  <input
                    id="firstLineSmallFont"
                    v-model="item.text_size_type"
                    type="radio"
                    name="firstLineFont"
                    value="small"
                    :checked="true"
                    :disabled="data.fontSizeBlockList.indexOf('small') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="firstLineSmallFont"
                    v-html="$t('mov_making.text_little')"
                  ></label>
                  <input
                    id="firstLineMidiumFont"
                    v-model="item.text_size_type"
                    type="radio"
                    name="firstLineFont"
                    value="midium"
                    :checked="item.text_size_type === 'midium'"
                    :disabled="data.fontSizeBlockList.indexOf('midium') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="firstLineMidiumFont"
                    v-html="$t('mov_making.text_midium')"
                  ></label>
                  <input
                    id="firstLineBigFont"
                    v-model="item.text_size_type"
                    type="radio"
                    name="firstLineFont"
                    value="large"
                    :checked="item.text_size_type === 'large'"
                    :disabled="data.fontSizeBlockList.indexOf('large') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="firstLineBigFont"
                    v-html="$t('mov_making.text_big')"
                  ></label>
                </div>
              </div>
              <div v-if="item.multi_line_yn === 'Y'" class="form-box">
                <label
                  v-html="
                    `${$t('mov_making.second_line')}<br>${$t(
                      'mov_making.text_size',
                    )}`
                  "
                ></label>
                <div class="radio-box">
                  <input
                    id="secondLineSmallFont"
                    v-model="item.text_size_type_second"
                    type="radio"
                    value="small"
                    :checked="item.text_size_type_second === 'small'"
                    :disabled="data.fontSizeBlockList.indexOf('small') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="secondLineSmallFont"
                    v-html="$t('mov_making.text_little')"
                  ></label>
                  <input
                    id="secondLineMidiumFont"
                    v-model="item.text_size_type_second"
                    type="radio"
                    value="midium"
                    :checked="item.text_size_type_second === 'midium'"
                    :disabled="data.fontSizeBlockList.indexOf('midium') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="secondLineMidiumFont"
                    v-html="$t('mov_making.text_midium')"
                  ></label>
                  <input
                    id="secondLineBigFont"
                    v-model="item.text_size_type_second"
                    type="radio"
                    value="large"
                    :checked="item.text_size_type_second === 'large'"
                    :disabled="data.fontSizeBlockList.indexOf('large') !== -1"
                    @change="resetText(i)"
                  />
                  <label
                    for="secondLineBigFont"
                    v-html="$t('mov_making.text_big')"
                  ></label>
                </div>
              </div>
              <div class="form-box">
                <label v-text="$t('common.text_location')"></label>
                <div class="radio-box">
                  <input
                    id="center"
                    v-model="item.textVerticalAlign"
                    type="radio"
                    name="textLocation"
                    value="center"
                    :checked="item.textVerticalAlign === 'center'"
                    @click="resetText(i)"
                  />
                  <label for="center" v-html="$t('common.center')"></label>
                  <input
                    id="top"
                    v-model="item.textVerticalAlign"
                    type="radio"
                    name="textLocation"
                    value="top"
                    :checked="item.textVerticalAlign === 'top'"
                    :disabled="!data.isSelectTextLocation"
                    @click="resetText(i)"
                  />
                  <label for="top" v-html="$t('common.top')"></label>
                  <input
                    id="bottom"
                    v-model="item.textVerticalAlign"
                    type="radio"
                    name="textLocation"
                    value="bottom"
                    :checked="item.textVerticalAlign === 'bottom'"
                    :disabled="!data.isSelectTextLocation"
                    @click="resetText(i)"
                  />
                  <label v-html="$t('common.bottom')" for="bottom"></label>
                </div>
              </div>
              <div class="form-box">
                <label v-text="$t('mov_making.line_cnt')"></label>
                <div class="radio-box">
                  <input
                    id="single"
                    type="radio"
                    name="multiLine"
                    value="N"
                    :checked="item.multi_line_yn !== 'Y'"
                    @click="setTextValue(i, 'N')"
                  />
                  <label
                    for="single"
                    v-html="1 + $t('common.text_line')"
                  ></label>
                  <input
                    id="multi"
                    type="radio"
                    name="multiLine"
                    value="Y"
                    :checked="item.multi_line_yn === 'Y'"
                    @click="setTextValue(i, 'Y')"
                  />
                  <label
                    for="multi"
                    v-html="2 + $t('common.text_line')"
                  ></label>
                </div>
              </div>
              <div class="form-box">
                <label
                  for="effectSelect"
                  v-html="$t('mov_making.movtxt_effect')"
                ></label>
                <select
                  id="effectSelect"
                  v-model="item.animation_name"
                  class="effect-select"
                  @change="onSelectAnimation(item)"
                >
                  <template v-for="i in data.opt_txt_effect.length">
                    <option
                      v-if="checkShowAnimation(data.opt_txt_effect[i - 1])"
                      :key="i"
                      :value="data.opt_txt_effect[i - 1]"
                      :disabled="
                        item.textVerticalAlign !== 'center' &&
                        data.animationBlockList.includes(
                          data.opt_txt_effect[i - 1],
                        )
                      "
                      v-html="$t('mov_making.' + data.opt_txt_effect[i - 1])"
                    ></option>
                  </template>
                </select>
              </div>
              <div v-if="data.step_type === 'upload'" class="form-box">
                <label v-html="$t('mov_making.line_cnt')"></label>
                <button
                  type="button"
                  class="button primary"
                  @click.prevent="
                    multiLineYN(i, data.text_list[i].multi_line_yn)
                  "
                >
                  <span
                    v-if="data.text_list[i].multi_line_yn === 'Y'"
                    v-html="1 + $t('mov_making.change_into_line')"
                  ></span>
                  <span
                    v-if="data.text_list[i].multi_line_yn === 'N'"
                    v-html="2 + $t('mov_making.change_into_line')"
                  ></span>
                </button>
              </div>
              <div v-show="item.multi_line_yn === 'Y'">
                <div class="form-box">
                  <label
                    :for="'first_line_' + i"
                    v-html="`${$t('mov_making.movtxt')} #${data.clicked_text}`"
                  ></label>
                  <input
                    :id="'first_line_' + i"
                    :ref="'first_line_' + i"
                    v-model="item.first_line"
                    type="text"
                    class="mov_text text-row"
                    :placeholder="
                      $t('mov_making.placeholder_text_limit', {
                        cnt: item.first_line_limit,
                      })
                    "
                    @input="changeTextLimit($event, i, 'first_line')"
                  />
                </div>
                <div class="form-box">
                  <label :for="'second_line_' + i"></label>
                  <input
                    :id="'second_line_' + i"
                    :ref="'second_line_' + i"
                    v-model="item.second_line"
                    type="text"
                    class="mov_text text-row"
                    :placeholder="
                      $t('mov_making.placeholder_text_limit', {
                        cnt: item.second_line_limit,
                      })
                    "
                    @input="changeTextLimit($event, i, 'second_line')"
                  />
                </div>
              </div>
              <div v-show="item.multi_line_yn === 'N'" class="form-box">
                <label
                  :for="'first_line_' + i"
                  v-html="`${$t('mov_making.movtxt')} #${data.clicked_text}`"
                ></label>
                <input
                  :id="'first_line_' + i"
                  :ref="'first_line_' + i"
                  v-model="item.first_line"
                  type="text"
                  class="mov_text text-row"
                  :placeholder="
                    $t('mov_making.placeholder_text_limit', {
                      cnt: item.first_line_limit,
                    })
                  "
                  @input="changeTextLimit($event, i, 'first_line')"
                />
              </div>
              <div class="form-box">
                <label v-text="$t('mov_making.movtxt_color')"></label>
                <input v-model="item.color_hex" type="color" />
              </div>
              <div class="form-box">
                <label v-text="$t('mov_making.movtxt_border_color')"></label>
                <input v-model="item.border_color_hex" type="color" />
              </div>
            </div>
          </div>
        </div>
        <div class="type-box">
          <p
            class="warning"
            v-html="$t('mov_making.desc_encoding_warning')"
          ></p>
        </div>
      </form>
    </div>
    <div class="footer">
      <button
        type="button"
        class="button primary"
        @click.prevent="goPrev(data.prev_screen_type)"
        v-text="$t('common.t_prev')"
      ></button>
      <button
        id="makeVideo"
        type="button"
        :class="[
          'button',
          { primary: data.mov_name },
          { normal: !data.mov_name },
        ]"
        @click.prevent="goNext(data.step_type)"
        v-text="$t('mov_making.btn_make_mov')"
      ></button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Cookies from 'js-cookie';
import { fabric } from 'fabric';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import EventBus from '@utils/bus';
import Utils from '@action/util';
import TextAnimationSetting from '@action/text_animation_setting';
import videoData from '@api/video';

const data = {
  access_type: undefined,
  theme_id: undefined,
  mov_name: '',
  category_id: undefined,
  txt_effect: '',
  txt_color: '',
  img_list: {},
  opt_txt_effect: [],
  preview_mov: '',
  width: 0,
  height: 0,
  duration: 0,
  currentTime: 0,
  is_play: false,
  text_img_list: [],
  text_list: [],
  text_limit: 13,
  fb: null,
  fbSecond: null,
  fbText: null, // fabric.IText
  fbTextSecondLine: null,
  cloneFirstLine: null,
  cloneSecondLine: null,
  clicked_text: 1,
  step_type: null,
  file_name: null,
  category_name: undefined,
  file_data: undefined,
  reg_date: undefined,
  file_info: undefined,
  timer: undefined,
  text_list_index: 0,
  product_type_info: [],
  product_type_id: '',
  prev_screen_type: '',
  arrSelectTextSize: [],
  isVerticalAnimationCondition: false,
  isBannerCondition: false,
  isSelectTextMultiLine: true,
  isSelectTextLocation: true, // check whether to show the select box
  animationBlockList: [
    'slide_top',
    'slide_bottom',
    'drift_top',
    'drift_bottom',
  ],
  fontSizeBlockList: [],
  isShowTab: true,
  encoding_type: '',
  imageStyle: {
    'max-width': '750px',
    'overflow-x': 'auto',
    'overflow-y': 'hidden',
  },
  containerStyle: {},
  elementOnTop: 'text',
  stickers: [],
  dragStatusCount: 0,
  isShowStickerList: false,
  isAlertDuplicated: false,
  addedImageURL: '',
  isPressed: false,
  isMultiCanvas: false,
};

export default {
  name: 'mov_effect',
  head: {
    title: {
      inner: 'Video',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Edit Video Of Smart Solution',
      },
    ],
  },
  props: ['step_type', 'step_info'],
  data() {
    return {
      data,
      access_type: '',
      selected_lang: '',
      isUseText: true,
    };
  },
  async created() {
    videoData.data.is_view_control = true;
    data.access_type = sessionStorage.getItem('access_type');
    data.product_type_info = videoData.product_type_info;
    data.width = data.product_type_info.h_res;
    data.height = data.product_type_info.v_res;
    data.rotate = data.product_type_info.rotate;
    data.step_type = this.step_type;
    data.prev_screen_type = this.step_type;
    data.product_type_id = this.step_info.product_type_id;
    data.mov_name = this.step_info.title;
    data.isBannerCondition = videoData.feature.banner === 'Y';
    this.access_type = data.access_type;
    this.selected_lang = Cookies.get(Common.STORAGE_LANG);

    const { columns, rows, rotate } = data.product_type_info;

    if (columns === 1 && rows === 1 && rotate === 'V') {
      data.isVerticalAnimationCondition = true;
    }

    if (data.access_type === 'web') {
      if (data.width < 1000) {
        data.containerStyle['min-width'] = `${data.width + 140}px`;
      } else {
        data.containerStyle['min-width'] = '1070px';
      }
    }

    await this.dataInit();
    this.domEventInit();
  },
  methods: {
    async dataInit() {
      const stepInfo = this.step_info;
      data.file_name = stepInfo.file_name;
      data.reg_date = stepInfo.reg_date;
      data.img_list = stepInfo.img_list;
      data.encoding_type = stepInfo.encoding_type || '';

      if (data.step_type === 'theme') {
        data.theme_id = stepInfo.theme_id;
        data.category_id = stepInfo.cat_id;
        data.category_name = stepInfo.cat_name;

        const response = await this.$store.dispatch(
          'THEME_INFO',
          data.theme_id,
        );

        if (response.data.code === Common.CODE_OK) {
          const { items } = response.data;
          data.duration = items.time;
          TextAnimationSetting.textListInit(data, items.animations);
          TextAnimationSetting.checkBlockFontSize(data);
          data.product_type_id = items.product_type_id;
        }
      } else {
        data.file_info = stepInfo.size;
        data.duration = 15000;
        data.file_data = stepInfo.file_data;
        TextAnimationSetting.textListInit(data);
        TextAnimationSetting.checkBlockFontSize(data);
        data.product_type_id = stepInfo.product_type_id;
      }

      this.checkShowTab();
      this.checkAllowChangeLocation();
    },
    domEventInit() {
      setTimeout(() => {
        this.setCanvasEvent();

        // 스티커를 클릭한 후 delete 버튼을 누르면 삭제하도록 함
        window.addEventListener('keydown', (e) => {
          if (!data.fb) return;
          if (!data.fb.getActiveObject()) return;

          // Delete Key Pressed
          if (e.keyCode === 46) {
            this.removeSticker(e);
          }
        });

        // 웹뷰 해당 페이지 접근 시 스크롤 위치 최상단으로 지정
        window.scrollTo(0, 0);
        // 썸네일 이미지
        this.viewPreview();
      });
    },
    setCanvasEvent() {
      data.fb = TextAnimationSetting.setCanvasSetting('textCanvas', data);
      data.fbText = TextAnimationSetting.setTextSetting();
      data.fbTextSecondLine = TextAnimationSetting.setTextSetting();
      data.fb.add(data.fbText);
      data.fb.add(data.fbTextSecondLine);

      if (data.product_type_info.dup_type === 'D') {
        data.isMultiCanvas = true;
        data.fbSecond = TextAnimationSetting.setCanvasSetting(
          'textCanvasSecond',
          data,
        );
        data.cloneFirstLine = TextAnimationSetting.setTextSetting();
        data.cloneSecondLine = TextAnimationSetting.setTextSetting();
        data.fbSecond.add(data.cloneFirstLine);
        data.fbSecond.add(data.cloneSecondLine);
      } else {
        data.isMultiCanvas = false;
      }
    },
    viewPreview() {
      const key = `video${Math.floor(data.currentTime / 100) + 1}.jpg`;

      if (key === 'video1.jpg') {
        data.preview_mov = data.img_list[key];
        document.querySelector('#previewImage').src = data.img_list[key];
      }
    },
    validateImage(image) {
      // 이미지 타입인지 체크
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp'];
      if (validTypes.indexOf(image.type) === -1) {
        // 중복 알림 시 한개만 띄우도록 함
        if (!data.isAlertDuplicated) {
          alert(
            eve.Lang.t('mov_making.file_type_png', {
              file_type: 'png, jpg, bmp',
            }),
          );
          data.isAlertDuplicated = true;
          setTimeout(() => {
            data.isAlertDuplicated = false;
          }, 3000);
        }

        return false;
      }

      return true;
    },
    previewImage(image) {
      const that = this;
      const imgView = document.getElementById('image-preview');
      const img = document.createElement('img');
      img.style.width = '50px';
      img.style.height = '50px';
      img.style.cursor = 'move';
      img.style.margin = '0 5px 5px 0';
      img.draggable = true;
      img.addEventListener('dragstart', this.handleDragStart);
      img.addEventListener('dragend', this.handleDrop);
      img.addEventListener('click', this.removeBorderFromCanvas);
      img.addEventListener('mousedown', that.addBorderToCanvas.bind(that));
      imgView.appendChild(img);

      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.readAsDataURL(image);
    },
    removeBorderFromCanvas() {
      data.isPressed = false;
      document.querySelector('#textCanvas').style.border = '2px solid white';
    },
    addBorderToCanvas() {
      data.isPressed = true;
      this.doInterval();
    },
    doInterval() {
      const that = this;

      if (data.isPressed) {
        document.querySelector('#textCanvas').style.border =
          '2px solid #009eff';

        setTimeout(() => {
          that.doInterval();
        }, 200);
      }
    },
    changeClassTo(type) {
      if (type === 'dragging') {
        data.dragStatusCount += 1;
        document.querySelector('#drop').classList.add('dragging');
        document.querySelector('#drop').classList.remove('inactive');
      } else {
        data.dragStatusCount -= 1;
        if (data.dragStatusCount <= 0) {
          document.querySelector('#drop').classList.remove('dragging');
          document.querySelector('#drop').classList.add('inactive');
        }
      }
    },
    getImageHandleDragEnter() {
      this.changeClassTo('dragging');
    },
    getImageHandleDragLeave() {
      this.changeClassTo('inactive');
    },
    getImageHandleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    selectedFile(e) {
      this.changeClassTo('inactive');

      const selectedFiles = e.target.files;
      for (let i = 0, len = selectedFiles.length; i < len; i += 1) {
        if (this.validateImage(selectedFiles[i])) {
          this.previewImage(selectedFiles[i]);
          data.isShowStickerList = true;
        }
      }
    },
    getImageHandleDragDrop(e) {
      this.changeClassTo('inactive');

      e.preventDefault();
      const droppedFiles = e.dataTransfer.files;
      for (let i = 0, len = droppedFiles.length; i < len; i += 1) {
        if (this.validateImage(droppedFiles[i])) {
          this.previewImage(droppedFiles[i]);
          data.isShowStickerList = true;
        }
      }
    },
    handleDragStart(e) {
      const images = document.querySelectorAll('img');
      for (let i = 0; i < images.length; i += 1) {
        images[i].classList.remove('img_dragging');
      }
      e.target.classList.add('img_dragging');
    },
    handleDrop(e) {
      if (e.stopPropagation) {
        e.stopPropagation(); // stops the browser from redirecting.
      }

      data.isPressed = false;
      document.querySelector('#textCanvas').style.border = '2px solid white';

      // add image
      const img = document.querySelector('.img_dragging');
      const canvasClientRect = document
        .querySelector('#textCanvas')
        .getBoundingClientRect();
      const canvasOffsetX = canvasClientRect.left + window.scrollX;
      const canvasOffsetY = canvasClientRect.top + window.scrollY;
      const newImage = new fabric.Image(img, {
        left: e.pageX - canvasOffsetX, // 마우스가 위치한 곳에 이미지 추가
        top: e.pageY - canvasOffsetY,
        lockScailingX: true,
        lockScailingY: true,
      });

      data.stickers[_.size(data.stickers)] = this.setScale(newImage, data);
      data.fb.add(newImage);
      if (data.isMultiCanvas) {
        data.fbSecond.add(newImage);
      }
      return false;
    },
    setScale(newImage, { width, height }) {
      if (newImage.width <= width && newImage.height <= height) {
        return newImage;
      }

      let scaleX = 1;
      let scaleY = 1;

      if (width > height) {
        scaleX = (height / newImage.height) * 1;
        scaleY = (height / newImage.height) * 1;
      } else if (height > width) {
        scaleX = (width / newImage.width) * 1;
        scaleY = (width / newImage.width) * 1;
      }

      newImage.scaleX = scaleX;
      newImage.scaleY = scaleY;

      return newImage;
    },
    imageOptionSettiong(addedImage = undefined) {
      let imageOption = {};

      if (addedImage === undefined) {
        imageOption = {
          left: 0,
          top: 0,
          angle: 0,
          lockScailingX: true,
          lockScailingY: true,
        };
        imageOption.width = data.width;
        imageOption.height = data.height;
      } else {
        const { top, left, angle, scaleX, scaleY } = data.added_image;
        imageOption.top = top;
        imageOption.left = left;
        imageOption.angle = angle;
        imageOption.scaleX = scaleX;
        imageOption.scaleY = scaleY;

        data.added_image.setCoords();
      }

      return imageOption;
    },
    titleChange() {
      if (document.querySelector('#mov_name').value === '') {
        document.querySelector('#makeVideo').classList.remove('primary');
        document.querySelector('#makeVideo').classList.add('normal');
      } else {
        document.querySelector('#makeVideo').classList.add('primary');
        document.querySelector('#makeVideo').classList.remove('normal');
      }
    },
    formValid() {
      let isValid = true;

      if (this.checkText(data.mov_name) === false) {
        alert(eve.Lang.t('mov_making.eff_check_movname'));
        document.getElementById('mov_name').focus();
        isValid = false;
      }

      if (_.size(data.mov_name) > 50) {
        alert(this.$t('mov_form.tip_title_length', { cnt: 50 }));
        document.getElementById('mov_name').focus();
        isValid = false;
      }

      return isValid;
    },
    removeSticker(e) {
      e.preventDefault();

      const target = data.fb.getActiveObject();
      if (!_.size(target)) {
        alert(eve.Lang.t('mov_making.select_img_to_delete'));
        return;
      }

      // eslint-disable-next-line no-underscore-dangle
      if (target._objects) {
        // 여러개의 스티커를 선택한 경우
        // eslint-disable-next-line no-underscore-dangle
        target._objects.forEach((list) => {
          data.stickers.splice(data.stickers.indexOf(target), 1);
          data.fb.remove(list);
          if (data.isMultiCanvas) data.fbSecond.remove(list);
        });
      } else {
        // 한개의 스티커를 선택한 경우
        data.stickers.splice(data.stickers.indexOf(target), 1);
        data.fb.remove(target);
        if (data.isMultiCanvas) data.fbSecond.remove(target);
      }

      // 스티커 전체 선택 해제
      data.fb.discardActiveObject();
      if (data.isMultiCanvas) data.fbSecond.discardActiveObject();
    },
    stopPlay() {
      data.currentTime = 0;
      data.is_play = false;
      data.text_list_index = 0;
      data.fb.remove(...data.fb.getObjects());
      if (data.isMultiCanvas) {
        data.fbSecond.remove(...data.fbSecond.getObjects());
      }
      clearTimeout(data.timer);
    },
    clickPlay() {
      this.stopPlay();
      this.play();
    },
    play() {
      data.is_play = true;
      data.fb.discardActiveObject(); // 스티커 선택 전체해제

      this.drawImage();
      this.drawText();

      data.timer = setTimeout(() => {
        data.currentTime += 50;

        if (data.currentTime > data.duration) {
          data.currentTime = 0;
          data.is_play = false;
          data.text_list_index = 0;
          data.fb.remove(...data.fb.getObjects());
          if (data.isMultiCanvas) {
            data.fbSecond.remove(...data.fbSecond.getObjects());
          }
          return;
        }
        this.play();
      }, 50);
    },
    drawImage() {
      const key = `video${Math.floor(data.currentTime / 100) + 1}.jpg`;
      const url = data.img_list[key];

      if (!url) {
        return;
      }
      // image src 변경
      data.preview_mov = data.img_list[key];
    },
    drawText() {
      const textInfo = data.text_list[data.text_list_index];

      if (!textInfo) {
        return;
      }

      if (!data.isShowTab) {
        // 문구를 1개만 사용하는 경우
        if (data.currentTime === data.text_list[0].start_sec) {
          const diffTime = data.duration;
          this.executeAnimation(textInfo, diffTime);
        }
        return;
      }

      // 각 문구의 시작 시간에 맞게 애니메이션 실행
      if (
        Utils.numCuttingByUnit(data.text_list[0].start_sec, 50) ===
          data.currentTime ||
        Utils.numCuttingByUnit(data.text_list[1].start_sec, 50) ===
          data.currentTime ||
        Utils.numCuttingByUnit(data.text_list[2].start_sec, 50) ===
          data.currentTime
      ) {
        const diffTime = this.getDiffTime();
        this.executeAnimation(textInfo, diffTime);
        if (data.text_list_index !== 2) {
          data.text_list_index += 1;
        }
      }

      // 테마이면서 시작시간 설정이 되어있지 않은 경우를 위한 예외처리
      if (
        data.text_list[0].start_sec === 0 &&
        data.text_list[1].start_sec === 0 &&
        data.text_list[2].start_sec === 0
      ) {
        const diffTime = data.duration / 3;
        this.executeAnimation(textInfo, diffTime);
        if (data.text_list_index !== 2) data.text_list_index += 1;
      }
    },
    getDiffTime() {
      const len = data.text_list.length - 1;
      let diffTime = 0;
      if (len !== data.text_list_index) {
        const x = data.text_list[data.text_list_index].start_sec;
        const y = data.text_list[data.text_list_index + 1].start_sec;
        diffTime = y - x;
      } else {
        const x = data.text_list[data.text_list_index].start_sec;
        const y = data.duration;
        diffTime = y - x;
      }
      return diffTime;
    },
    executeAnimation(textInfo, diffTime) {
      // 영상 크기에 맞추어 폰트 사이즈 변경
      TextAnimationSetting.setFontSize(
        this.data,
        textInfo,
        textInfo.text_size_type,
        textInfo.text_size_type_second,
      );

      // 1x1 세로인경우 세로 텍스트 출력
      if (this.data.isVerticalAnimationCondition) {
        TextAnimationSetting.verticalAnimationText(
          this.data,
          textInfo,
          textInfo.animation_name,
          diffTime,
        );
      } else {
        TextAnimationSetting.setTextAnimation(
          this.data,
          textInfo,
          textInfo.animation_name,
          diffTime,
        );
      }
    },
    checkShowTab() {
      if (data.isVerticalAnimationCondition) {
        data.isShowTab =
          data.text_list[0].animation_name !== 'slide_bottom' &&
          data.text_list[0].animation_name !== 'slide_top';
      } else {
        data.isShowTab =
          data.text_list[0].animation_name !== 'slide_left' &&
          data.text_list[0].animation_name !== 'slide_right';
      }
    },
    checkShowAnimation(animationName) {
      let flag;

      if (data.clicked_text === 1) {
        flag = true;
      }
      if (data.isVerticalAnimationCondition) {
        flag =
          (data.clicked_text - 1 &&
            animationName !== 'slide_top' &&
            animationName !== 'slide_bottom') ||
          data.clicked_text === 1;
      } else {
        flag =
          (data.clicked_text - 1 &&
            animationName !== 'slide_left' &&
            animationName !== 'slide_right') ||
          data.clicked_text === 1;
      }

      return flag;
    },
    onSelectAnimation(item) {
      const { index, animation_name: animationName } = item;
      this.checkAllowChangeLocation(item);
      data.text_list[index - 1].animation_name = animationName;
      this.checkShowTab();
      TextAnimationSetting.setTextLimit(
        data.product_type_info,
        data,
        item.text_size_type,
        item.text_size_type_second,
      );
    },
    onTextTab(value) {
      data.clicked_text = value;
      TextAnimationSetting.checkBlockFontSize(data);
      this.checkAllowChangeLocation();
      this.checkShowTab();
    },
    multiLineYN(idx, value) {
      for (let i = 0; i < data.text_list.length; i += 1) {
        if (idx === i) {
          if (value === 'Y') {
            data.text_list[idx].multi_line_yn = 'N';
          } else {
            data.text_list[idx].multi_line_yn = 'Y';
          }
        }
      }
    },
    goPrev(type) {
      this.stopPlay();
      EventBus.$emit('move-back', type);
    },
    goNext(value) {
      if (this.formValid() === false) {
        return;
      }

      this.stopPlay();

      data.mov_name = data.mov_name.replace(/[$.]/g, '_'); // zip 확장자 출력 실패 해결
      const texts = [];

      if (value === 'theme') {
        for (let i = 0; i < data.text_list.length; i += 1) {
          texts.push({
            default_text: data.text_list[i].default_text,
            animation_id: 0,
            animation_name: data.text_list[i].animation_name,
            folder: `images${i}`,
            start_time: i * 5,
            end_time: (i + 1) * 5,
          });
        }
        const returnData = {
          type: Common.EVT_CB_SCREEN_TYPE,
          screen_type: 'encoding',
          data: {
            step_type: data.encoding_type ? data.encoding_type : data.step_type,
            step_info: {
              title: data.mov_name,
              reg_date: data.reg_date,
              img_list: data.img_list,
              text_list: data.text_list,
              product_type_id: data.product_type_id,
              duration: data.duration,
              animation_preset: data.animation_preset,
              stickers: data.stickers,
              read_data: data.read_data,
              image_option: this.imageOptionSettiong(data.added_image),
              added_image: data.added_image,
              elementOnTop: data.elementOnTop,
              isUseText: this.isUseText,
              encode_data: {
                title: data.mov_name,
                product_type_id: data.product_type_id,
                id: data.theme_id,
                texts,
                categories: {
                  name: data.category_name,
                  id: data.category_id,
                  duration: data.duration,
                },
              },
            },
          },
        };
        this.$emit('childs-event', returnData);
      } else if (value === 'upload' || value === 'upload-effect') {
        for (let i = 0; i < data.text_list.length; i += 1) {
          texts.push({
            default_text:
              `${data.text_list[i].first_line}\n` +
              `${data.text_list[i].second_line}`,
            animation_id: 0,
            animation_name: data.text_list[i].animation_name,
            folder: `images${i}`,
            start_time: i * 5,
            end_time: (i + 1) * 5,
          });
        }
        EventBus.$emit('childs-event', {
          type: Common.EVT_CB_SCREEN_TYPE,
          screen_type: 'encoding',
          data: {
            step_type: data.step_type,
            step_info: {
              title: data.mov_name,
              file: data.file_data,
              reg_date: data.reg_date,
              img_list: data.img_list,
              text_list: data.text_list,
              product_type_id: data.product_type_id,
              duration: data.duration,
              stickers: data.stickers,
              read_data: data.read_data,
              image_option: this.imageOptionSettiong(data.added_image),
              added_image: data.added_image,
              elementOnTop: data.elementOnTop,
              isUseText: this.isUseText,
              encode_data: {
                title: data.mov_name,
                product_type_id: videoData.data.product_type_id,
                movie_name: data.file_data.name,
                texts,
              },
            },
          },
        });
      }
    },
    checkText(text) {
      if (text === undefined) return false;
      if (text === '') return false;
      if (text === ' ') return false;

      return true;
    },
    clearMovName() {
      this.data.mov_name = '';
      document.querySelector('#makeVideo').classList.remove('primary');
      document.querySelector('#makeVideo').classList.add('normal');
      document.querySelector('#mov_name').focus();
    },
    // 텍스트 길이 제한
    changeTextLimit(event, idx, limitTextType) {
      const dataFirstLine = data.text_list[idx].first_line;
      const dataSecondLine = data.text_list[idx].second_line;
      const firstLineLimit = data.text_list[idx].first_line_limit;
      const secondLineLimit = data.text_list[idx].second_line_limit;
      let firstLineAllowSubmit = false;
      let secondLineAllowSubmit = false;
      event.returnValue = true;

      // 1. decide text limit number
      TextAnimationSetting.setTextLimit(
        data.product_type_info,
        data,
        data.text_list[idx].text_size_type,
        data.text_list[idx].text_size_type_second,
      );

      // 2. prevent keydown event by limit
      if (limitTextType === 'first_line') {
        if (dataFirstLine === undefined) return;
        if (
          event.target.value.length >= firstLineLimit &&
          event.target.id === limitTextType
        ) {
          // 첫번째줄 문구가 limit 개수를 넘으면 입력되지 못하도록 함
          if (!firstLineAllowSubmit) {
            event.preventDefault();
            if (limitTextType === 'first_type') {
              this.$refs[`first_line_${idx}`][0].value =
                event.target.value.substring(0, firstLineLimit);
            }
            data.text_list[idx].first_line = event.target.value.substring(
              0,
              firstLineLimit,
            );
          }
          firstLineAllowSubmit = true;
        }
      }

      if (limitTextType === 'second_line') {
        if (dataSecondLine === undefined) return;
        if (
          event.target.value.length >= secondLineLimit &&
          event.target.id === limitTextType
        ) {
          // 두번째줄 문구가 limit 개수를 넘으면 입력되지 못하도록 함
          if (!secondLineAllowSubmit) {
            event.preventDefault();
            if (limitTextType === 'second_type')
              this.$refs[`second_line_${idx}`][0].value =
                event.target.value.substring(0, secondLineLimit);
            data.text_list[idx].second_line = event.target.value.substring(
              0,
              secondLineLimit,
            );
          }
          secondLineAllowSubmit = true;
        }
      }
    },
    setTextValue(idx, value) {
      data.text_list[idx].multi_line_yn = value;
      TextAnimationSetting.checkBlockFontSize(data);
      TextAnimationSetting.setTextLimit(data.product_type_info, data);
      this.checkAllowChangeLocation(data.text_list[idx]);
      this.checkShowTab();
      data.text_list[idx].first_line = '';
      data.text_list[idx].second_line = '';
    },
    resetText(idx, multiLineYN = '') {
      TextAnimationSetting.checkBlockFontSize(data);
      if (multiLineYN) data.text_list[idx].multi_line_yn = multiLineYN;

      TextAnimationSetting.setTextLimit(
        data.product_type_info,
        data,
        data.text_list[idx].text_size_type,
        data.text_list[idx].text_size_type_second,
      );
      this.checkAllowChangeLocation(data.text_list[idx]);

      this.$refs[`first_line_${idx}`][0].value = '';
      this.$refs[`second_line_${idx}`][0].value = '';
      data.text_list[idx].first_line = '';
      data.text_list[idx].second_line = '';
    },
    checkAllowChangeLocation(item) {
      // initialization
      if (!item) item = this.data.text_list[data.clicked_text - 1];
      const signWidth = data.product_type_info.h_res;
      const signHeight = data.product_type_info.v_res;
      const isLargeFont =
        item.text_size_type === 'large' ||
        item.text_size_type_second === 'large';
      const isMidiumFont =
        item.text_size_type === 'midium' ||
        item.text_size_type_second === 'midium';
      const isMultiLine = item.multi_line_yn;

      // condition check
      const blockConditionList = [
        data.isBannerCondition,
        data.animationBlockList.includes(item.animation_name),
        signWidth === 80 && signHeight === 160,
        signWidth === 128 && signHeight === 256,
        signWidth === 320 && signHeight === 64,
        signWidth === 512 && signHeight === 128,
        signWidth === 768 && signHeight === 128,
        isLargeFont && signWidth === 256 && signHeight === 128,
        isMultiLine === 'Y' && signWidth === 128 && signHeight === 256,
        isMultiLine === 'Y' && signWidth === 320 && signHeight === 80,
        isMultiLine === 'Y' &&
          isMidiumFont &&
          signWidth === 160 &&
          signHeight === 80,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 160 &&
          signHeight === 160,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 256 &&
          signHeight === 256,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 320 &&
          signHeight === 160,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 480 &&
          signHeight === 240,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 512 &&
          signHeight === 256,
        isMultiLine === 'Y' &&
          isLargeFont &&
          signWidth === 768 &&
          signHeight === 384,
        isMultiLine === 'N' &&
          isLargeFont &&
          signWidth === 160 &&
          signHeight === 80,
        isMultiLine === 'N' &&
          isLargeFont &&
          signWidth === 320 &&
          signHeight === 80,
        isMultiLine === 'N' &&
          isLargeFont &&
          signWidth === 480 &&
          signHeight === 80,
      ];

      data.isSelectTextLocation = !blockConditionList.some(
        (isBlock) => isBlock === true,
      );

      if (data.isSelectTextLocation && item.textVerticalAlign !== 'center') {
        item.textVerticalAlign = 'center';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card.video-effect {
  max-width: 800px;
  background-color: $white;
  position: relative;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  margin: 0 auto;

  &.app {
    margin: 12px 0;
    padding: 20px 15px;
  }

  .header {
    h2 {
      margin: 0;
      font-size: 24px;
    }
  }

  .body {
    margin-top: 20px;
    background-color: $white;

    .information {
      font-size: 12px;
      color: $gray-33;
      line-height: 1.5em;
    }

    .warning {
      margin: 16px 0 0 0;
      font-weight: bold;
      font-size: 12px;
      line-height: 1.25rem;
      color: $gray-33;
      text-align: center;
    }

    .form-box {
      display: flex;
      align-items: flex-start;
      position: relative;
      margin-top: 16px;
      max-width: 1000px;

      &:first-child {
        margin-top: 0px;
      }

      label {
        min-width: 108px;
        padding-top: 12px;
        font-size: 14px;
      }

      label.multi-line-title {
        line-height: 170%;
        margin: 0;
        padding: 0;
      }

      label + * {
        margin-left: 12px;
      }

      label.help {
        color: $primary;
        padding: 0;
        margin: 0px 12px 0px;
      }

      select,
      input,
      .button {
        height: 44px;
      }

      input[type='text'] {
        font-size: 16px;
      }

      input[type='text'].mov_text {
        flex: 1 1 calc(100% - 121px);
      }

      input[type='text']::placeholder {
        text-align: right;
        padding-right: 15px;
        font-size: 13px;
      }

      input[type='color'] {
        width: 40px;
        height: 18px;
        padding: 0;
        margin-top: 12px;
      }

      select {
        flex: 1 1 calc(100% - 121px);

        option:disabled {
          background-color: $gray-f8;
          color: $gray-bf;
        }
      }

      select + input {
        width: 100%;
      }

      .button {
        min-width: 100px;
        padding: 0;
      }

      .removeButton {
        border: 1px solid #f87b27;
        color: #f87b27;
        background-color: transparent;
        min-width: 160px;
        padding: 0px 10px;
        height: 44px;
        font-size: 14px;
      }

      .removeButton:hover {
        background-color: #f87b27;
        color: white;
      }

      .button-delete {
        display: none;
        position: absolute;
        top: 50%;
        right: 10px;
        width: 20px;
        height: 20px;
        border: 1px solid #000000;
        border-radius: 50%;
        background: #ffffff;
        color: #000000;
        text-align: center;
        transform: translateY(-50%);

        &.show {
          display: block;
        }
      }

      .radio-box {
        margin-top: 10px;
        position: relative;
        width: 100%;
        display: flex;

        label {
          display: inline-block;
          border: 1px solid $gray-e6;
          color: $gray-66;
          min-width: 10px;
          width: 100%;
          padding: 10px 0px;
          text-align: center;
          line-height: 100%;
        }

        input {
          visibility: hidden;
          position: absolute;
        }

        input[type='radio']:checked + label,
        input[type='radio'] + label:hover {
          background-color: #f2faff;
          color: #0075ba;
          border: 1px solid #009eff;
        }

        input[type='radio']:disabled + label {
          background-color: $gray-f8;
          color: $gray-bf;
          border: 1.5px solid #e6e6e6;
        }
      }

      .effect {
        padding-top: 5px;
        padding-bottom: 5px;

        .image-row {
          max-width: 879px;
          overflow-x: scroll;
          overflow-y: hidden;

          .canvas-box {
            position: relative;
            display: flex;
            align-items: flex-start;

            img,
            canvas {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }
        }

        .button-row {
          margin-top: 10px;
        }
      }

      #select-sticker {
        border: 1px solid #e6e6e6;
        padding: 15px;
        width: 100%;
        max-height: 165px;
        overflow-y: scroll;

        input {
          border: 0;
          padding: 0;
        }

        .stickers {
          div {
            display: inline;
          }

          .sticker_container {
            padding: 0px 10px;
          }
        }
      }

      #drop {
        width: 100%;
        position: relative;

        label {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          padding: 25px 0 20px;
          text-align: center;
          font-size: 13px;
          line-height: 200%;
        }

        input[type='file'] {
          visibility: hidden;
          position: absolute;
          z-index: -1;
        }
      }

      #drop.inactive {
        border: 2px dashed $gray-e6;

        label {
          color: $gray-26;
        }
      }

      #drop.dragging {
        border: 2px solid $primary;

        label {
          color: $primary;
        }
      }

      .text-row {
        margin-top: 12px;

        ul {
          display: inline-flex;
          padding-bottom: 10px;

          li {
            cursor: pointer;
            text-align: center;
            padding-bottom: 10px;

            span {
              font-size: 16px;
              color: $primary;
            }

            &.clicked-tab {
              font-weight: bold;
              border-bottom: 2px solid $primary;
              padding-bottom: 8px;

              span {
                color: $white;
              }
            }
          }

          li + li {
            margin-left: 5px;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .button {
      width: 120px;
      height: 44px;
    }

    .button + .button {
      margin-left: 12px;
    }
  }
}
</style>
